import React, { useState } from "react";
import { Button, Modal, Form, Col } from "react-bootstrap";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { ToastContainer, toast, Slide } from "react-toastify";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid"; // Untuk generate form ID
import { MdFileUpload } from "react-icons/md";
import axios from "axios";
import { API_URL } from "../../../utilities/url";
import storage from "../../../services/storage";
import CryptoJS from "crypto-js";
import authService from "../../../services/auth.service";

// Register plugin untuk preview gambar di FilePond
registerPlugin(FilePondPluginImagePreview);

const UploadMediaModal = ({ onUploadSuccess }) => {
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const [show, setShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    shouldFocusError: false,
    reValidateMode: "onBlur",
  });

  // Handle modal
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setFiles([]);
    setFileName("");
    setValue("description", "");
    clearErrors();
  };

  // Handle file upload di FilePond
  const handleFileUpdate = (fileItems) => {
    setFiles(fileItems);
    if (fileItems.length > 0) {
      const file = fileItems[0].file;
      const nameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");

      setFileName(nameWithoutExtension);
      setValue("fileName", nameWithoutExtension);
    } else {
      setFileName("");
      setValue("fileName", "");
    }
  };

  // Handle form submit
  const onSubmit = (data) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("idt_workspace", workspace.idt_user_workspace);
    formData.append("file_id", uuidv4());
    formData.append("name", data.fileName);
    formData.append("description", data.description || "");
    formData.append("file", files[0]?.file);

    // console.log("Data yang dikirim:", {
    //   formId: uuidv4(),
    //   fileName: data.fileName,
    //   description: data.description || "",
    //   file: files[0]?.file || "",
    // });

    axios
      .post(API_URL + "upload-media-storage", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${storage.get("access_token")}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success("Upload Media Storage Successfull", {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
          onUploadSuccess();
          // Jika perlu mengambil ulang data setelah upload berhasil
          // getSomeData();

          handleClose(); // Tutup modal setelah upload sukses
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <>
      {/* Tombol untuk membuka modal */}
      <Button className="btn btn-primary ms-auto" onClick={handleShow}>
        <MdFileUpload className="me-1" size={18} />
        Upload Media
      </Button>

      {/* Modal Upload */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Media</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          <Modal.Body>
            {/* File Upload menggunakan FilePond */}
            <FilePond
              files={files}
              onupdatefiles={handleFileUpdate}
              allowMultiple={false}
              maxFiles={1}
              labelIdle='Drag & Drop or <span class="filepond--label-action">Choose File</span>'
              imagePreviewMaxHeight={300}
              stylePanelAspectRatio="0"
              imageTransformOutputFit="cover"
            />
            {files.length > 0 && (
              <>
                <Form.Group>
                  <Form.Label column sm={3} className="text-sm-right">
                    File Name <span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    {...register("fileName", {
                      required: "File Name is required",
                    })}
                    className={errors.fileName ? "is-invalid" : ""}
                    value={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                  />
                  {errors.fileName && (
                    <div className="invalid-feedback">
                      {errors.fileName.message}
                    </div>
                  )}
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    {...register("description")}
                  />
                </Form.Group>
              </>
            )}
          </Modal.Body>
          {files.length > 0 && (
            <Modal.Footer className="mt-3">
              <Button variant="danger" onClick={handleClose}>
                Cancel
              </Button>
              <Button type="submit" variant="success" disabled={loading}>
                <span
                  className={`spinner-border spinner-border-xs me-2 ${
                    !loading ? "d-none" : ""
                  }`}
                  role="status"
                  aria-hidden="true"
                ></span>
                Upload
              </Button>
            </Modal.Footer>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default UploadMediaModal;
